import { render, staticRenderFns } from "./manifest.vue?vue&type=template&id=2dbf233e"
import script from "./manifest.vue?vue&type=script&lang=js"
export * from "./manifest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports